import { PermissionDTO } from '@/api/trafikportalen';

export const VIEWS: { type: string; views: ViewConfig[] }[] = [
  {
    type: 'department',
    views: [
      {
        label: 'tab.information',
        path: 'information',
      },
      {
        label: 'tab.travellers',
        path: 'travellers',
      },
      {
        label: 'tab.admins',
        path: 'admins',
      },
      {
        label: 'tab.advanced',
        path: 'advanced',
      },
    ],
  },
  {
    type: 'traveller',
    views: [
      {
        label: 'tab.profile',
        path: 'profile',
      },
      {
        label: 'tab.tickets',
        path: 'tickets',
      },
      {
        label: 'tab.advanced',
        path: 'advanced',
      },
    ],
  },
  {
    type: 'students',
    views: [
      {
        label: 'tab.profile',
        path: 'profile',
      },
      {
        label: 'tab.advanced',
        path: 'advanced',
      },
    ],
  },
  {
    type: 'students/travels',
    views: [
      {
        label: 'tab.list',
        path: 'list',
      },
      {
        label: 'tab.imports',
        path: 'imports',
      },
      {
        label: 'tab.admins',
        path: 'admins',
      },
      {
        label: 'tab.invoicing',
        path: 'invoicing',
      },
      {
        label: 'tab.periods',
        path: 'periods',
      },
      {
        label: 'tab.info',
        path: 'info',
      },
    ],
  },
  {
    type: 'students/child-and-youth',
    views: [
      {
        label: 'tab.list',
        path: 'list',
      },
      {
        label: 'tab.imports',
        path: 'imports',
      },
      {
        label: 'tab.admins',
        path: 'admins',
      },
      {
        label: 'tab.invoicing',
        path: 'invoicing',
      },
      {
        label: 'tab.periods',
        path: 'periods',
      },
      {
        label: 'tab.info',
        path: 'info',
      },
    ],
  },
  {
    type: 'students/transportation',
    views: [
      {
        label: 'tab.list',
        path: 'list',
      },
      {
        label: 'tab.imports',
        path: 'imports',
      },
      {
        label: 'tab.admins',
        path: 'admins',
      },
      {
        label: 'tab.invoicing',
        path: 'invoicing',
      },
      {
        label: 'tab.periods',
        path: 'periods',
      },
      {
        label: 'tab.info',
        path: 'info',
      },
    ],
  },
  {
    type: 'organizations',
    views: [
      {
        label: 'tab.organizations',
        path: 'list',
      },
      {
        label: 'tab.applications',
        path: 'applications',
      },
    ],
  },
  {
    type: 'organization',
    views: [
      {
        label: 'tab.information',
        path: 'information',
      },
      {
        label: 'tab.ticket_settings',
        path: 'tickets',
      },
      {
        label: 'tab.students',
        path: 'students',
      },
      {
        label: 'tab.payers',
        path: 'payers',
      },
      {
        label: 'tab.advanced',
        path: 'advanced',
      },
    ],
  },
  {
    type: 'tenant-settings',
    views: [
      {
        label: 'tab.information_pages',
        path: 'information',
      },
      {
        label: 'tab.configuration',
        path: 'configuration',
        permission: 'tenant:editor',
      },
    ],
  },
  {
    type: 'administrator',
    views: [
      {
        label: 'tab.profile',
        path: 'profile',
      },
      {
        label: 'tab.advanced',
        path: 'advanced',
      },
    ],
  },
  {
    type: 'systemadministrator',
    views: [
      {
        label: 'tab.profile',
        path: 'profile',
      },
      {
        label: 'tab.advanced',
        path: 'advanced',
        permission: 'tenant:editor',
      },
    ],
  },
  {
    type: 'reports',
    views: [
      {
        label: 'tab.transactions',
        path: 'transactions',
      },
      {
        label: 'tab.files',
        path: 'files',
      },
    ],
  },
] as const;

export type TabViewsType = typeof VIEWS;
export type TabType = TabViewsType[number]['type'];
export type ViewConfig = {
  label: string;
  path: string;
  permission?: PermissionDTO;
  defaultMessage?: string;
};

export type ViewPaths<T extends TabType> = Extract<
  TabViewsType[number],
  { type: T }
>['views'][number]['path'];

// Helper types
export type DepartmentViewType = ViewPaths<'department'>;
export type TravellerViewType = ViewPaths<'traveller'>;
export type StudentViewType = ViewPaths<'students'>;
